"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddLeaguePlatformDto = instanceOfAddLeaguePlatformDto;
exports.AddLeaguePlatformDtoFromJSON = AddLeaguePlatformDtoFromJSON;
exports.AddLeaguePlatformDtoFromJSONTyped = AddLeaguePlatformDtoFromJSONTyped;
exports.AddLeaguePlatformDtoToJSON = AddLeaguePlatformDtoToJSON;
exports.AddLeaguePlatformDtoToJSONTyped = AddLeaguePlatformDtoToJSONTyped;
/**
 * Check if a given object implements the AddLeaguePlatformDto interface.
 */
function instanceOfAddLeaguePlatformDto(value) {
    if (!('leagueId' in value) || value['leagueId'] === undefined)
        return false;
    if (!('streamingPlatformId' in value) || value['streamingPlatformId'] === undefined)
        return false;
    return true;
}
function AddLeaguePlatformDtoFromJSON(json) {
    return AddLeaguePlatformDtoFromJSONTyped(json, false);
}
function AddLeaguePlatformDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'leagueId': json['leagueId'],
        'streamingPlatformId': json['streamingPlatformId'],
    };
}
function AddLeaguePlatformDtoToJSON(json) {
    return AddLeaguePlatformDtoToJSONTyped(json, false);
}
function AddLeaguePlatformDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'leagueId': value['leagueId'],
        'streamingPlatformId': value['streamingPlatformId'],
    };
}
